import { useState } from 'react';
import EcCart from '@components/icons/components/EcCart';
import styles from './CartButton.styles';
import { IProductObject } from '@features/categories/typescript';
import ProductGalleryBlockModal from '@features/cms/components/collections/ProductGalleryBlock/ProductGalleryBlockModal/ProductGalleryBlockModal';
import { IParsedImage, TImage, TVideo } from '@components/typescript';
import dynamic from 'next/dynamic';
import { TProductGallerySlide } from '@features/cms/typescript';
import { useTranslation } from 'next-i18next';
export interface CartButtonProps {
  label?: string;
  products?: IProductObject[] | null;
  image?: IParsedImage | TImage | null;
  video?: TVideo | null;
}
const CartButton = ({
  products = [],
  image,
  video
}: CartButtonProps) => {
  const {
    t
  } = useTranslation('common');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const DynamicModalRootPortal = dynamic(() => import('@components/ModalRootPortal/ModalRootPortal'), {
    ssr: false
  });
  const modalData = {
    products,
    image: image,
    video: video,
    itemId: 'singleImage'
  };
  const hasProducts = products && products.length > 0;
  const handleClick = () => {
    if (hasProducts) {
      setIsModalOpen(true);
    }
  };
  return <>
      <div sx={styles.hitArea} onClick={handleClick} onKeyDown={e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleClick();
      }
    }} role="button" tabIndex={0} aria-label={t('cart.viewProducts')} data-testid="CartButton">
        <div sx={styles.container} data-testid="CartButton-container">
          <div sx={styles.button} data-testid="CartButton-button">
            <svg className="dashed-border" preserveAspectRatio="none" style={{
            position: 'absolute',
            top: '-1px',
            left: '-1px',
            width: 'calc(100% + 2px)',
            height: 'calc(100% + 2px)',
            overflow: 'visible'
          }}>
              <rect x="0.5" y="0.5" style={{
              width: 'calc(100% - 1px)',
              height: 'calc(100% - 1px)'
            }} rx="24" ry="24" />
            </svg>
            <div sx={styles.iconWrapper} className="icon-wrapper" data-testid="CartButton-iconWrapper">
              <EcCart />
            </div>
            <span sx={styles.buttonText} className="cart-button-text" data-testid="CartButton-buttonText">
              {t('cart.viewProducts')}
            </span>
          </div>
        </div>
      </div>

      {hasProducts && isModalOpen && <DynamicModalRootPortal>
          <ProductGalleryBlockModal isActive={isModalOpen} slide={modalData as TProductGallerySlide<IParsedImage>} onClose={() => setIsModalOpen(false)} />
        </DynamicModalRootPortal>}
    </>;
};
export default CartButton;